export default "__VITE_ASSET__BQoqe09n__"